export function buildMemberAssignmentState({ cardId, previousMembers, memberProfile, userId, isGeneralPool }) {
    const members = memberProfile && !previousMembers.some(member => member.user_id === userId)
        ? [...previousMembers, { card_id: cardId, user_id: userId, profiles: memberProfile }]
        : previousMembers
    const nextMembers = isGeneralPool
        ? members.map(member => ({ ...member, claimed_at: null }))
        : members

    return {
        nextMembers,
        dashboardPatch: {
            card_members: nextMembers,
            _assignees: nextMembers.map(member => member.profiles).filter(Boolean),
            ...(isGeneralPool ? {
                is_general_pool: false,
                claimed_by: null,
                claimed_at: null,
                _claimedByProfile: null,
                _claimedProfiles: [],
                _claimedUserIds: [],
                _claimedByName: '',
            } : {}),
        },
    }
}
